<template>    
    <PageFull header="Адм. партнеры" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <PartnerList />
            </div>
        </template>
    </PageFull>
</template>

<script>
import PartnerList from '@/components/admin/PartnerList.vue'
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        PartnerList,
        PageFull  
    },
}
</script>